import { render, staticRenderFns } from "./_playngo.vue?vue&type=template&id=7162c586&lang=pug&"
import script from "./_playngo.vue?vue&type=script&lang=js&"
export * from "./_playngo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports